import { useContext, useState, useEffect, useRef } from 'react'
import { MusicPlayerContext } from '../context/MusicPlayerContext'
import { httpToHttps } from '../utils/helper-functions'

export const useMusicPlayer = () => {
  const [state, setState] = useContext( MusicPlayerContext )
  // eslint-disable-next-line
  const [error, setError] = useState( false )
  const [time, setTime] = useState( 0 )
  const [duration, setDuration] = useState( 0 )
  const trackProgress = time / duration || 0
  const [volume, setVolume] = useState( 40 )
  const audioRef = useRef( null )

  /** Show loading animation.
  var playPromise = video.play();
  if ( playPromise !== undefined ) {
      playPromise.then( _ => {
          // Automatic playback started!
          // Show playing UI.
      } )
          .catch( error => {
              // Auto-play was prevented
              // Show paused UI.
          } );
  } */

  // Play a specific track
  function playTrack( index ) {
    if ( index === state.currentTrackIndex && state.tracks[index]?.id !== -1 ) {
      togglePlay()
    } else {
      state.audioPlayer.pause()
      const playAttempt = setInterval( () => {
        const playPromise = state.audioPlayer.play()
        if ( playPromise || playPromise !== undefined ) {
          playPromise.then( () => {
            clearInterval( playAttempt )
          } ).catch( e => {
            setError( true )
            // console.log( `Playback Error ${e}` )
          } )
        }
      }, 400 )
      state.audioPlayer.load()
      state.audioPlayer.crossOrigin = 'anonymous'
      state.audioPlayer.preload = "auto"
      state.audioPlayer = new Audio( state.tracks[index].file || httpToHttps( state.tracks[index].url || httpToHttps( state.tracks[index].mp3Url ) ) )
      setState( state => ( { ...state, currentTrackIndex: index, isPlaying: true } ) )
    }
  }


  // const startTimer = () => {
  //     // pass in intervalRef.current
  //     clearInterval()
  //     intervalRef.current = setInterval(()=>{
  //      if(audioRef.current.ended){
  //     playNextTrack()
  //     } else {
  //     onSeek(audioRef.current.currentTime)
  //     }
  //        }, [1000])
  //     }

  // Toggle play or pause
  function togglePlay() {
    if ( state.isPlaying ) {
      state.audioPlayer.pause()
    } else {
      state.audioPlayer.play()
    }
    setState( state => ( { ...state, isPlaying: !state.isPlaying } ) )
  }

  // Play the previous track in the tracks array
  function playPreviousTrack() {
    const newIndex = ( ( state.currentTrackIndex + -1 ) % state.tracks.length + state.tracks.length ) % state.tracks.length
    console.log( newIndex )
    playTrack( newIndex )
  }
  // Play the next track in the tracks array
  function playNextTrack() {
    const newIndex = ( state.currentTrackIndex + 1 ) % state.tracks.length
    playTrack( newIndex )
  }

  /**	setInterval(() => {
      setLength(Math.ceil(player.duration))
      setCurrLength(Math.ceil(player.currentTime))
      let secPerPx = Math.ceil(player.duration) / 280
      let newWidth = player.currentTime / secPerPx
      document.querySelector('.progressBar').style.width = newWidth+"px"
      if(player.currentTime === player.duration){
          if(options.shuffle === true){
              props.setIdx((parseInt(Math.random()*1000))%9)
          }
          else if(options.repeat === true){
              player.play()
          }
          else{
              props.setIdx((props.idx+1)%9)
          }
      }
  }, 1000);
   */

  // console.log( Math.ceil( state.audioPlayer.currentTime ) === Math.ceil( state.audioPlayer.duration ), "currentTime === duration" )

  // Song progress 
  const onSeek = ( e ) => {
    const n = e.clientX - e.target.offsetLeft
    const p = n / e.target.offsetWidth
    state.audioPlayer.currentTime = p * duration
    // console.log( n, p, "onSeek", trackProgress )
  }

  // Play Repeat and Shuffle
  function toggleRepeat( index ) {
    if ( !state.isPlaying ) return
    setState( state => ( { ...state, isPlaying: state.isPlaying, isRepeatOn: true } ) )
    console.log( "isRepeatOn", state.isRepeatOn )
  }

  //isShuffleOn
  function toggleShuffle() {
    console.log( "Shuffle clicked", state.isShuffleOn )
    state.isShuffleOn = !state.isShuffleOn
    state.isRepeatOn = false
  }

  useEffect( () => {
    state.audioPlayer.addEventListener( 'ended', () => ( { ...state, isPlaying: !state.isPlaying } ) )
    return () => {
      state.audioPlayer.removeEventListener( 'ended', () => ( { ...state, isPlaying: !state.isPlaying } ) )
    }
  }, [] )

  function handleSongEnded() {
    if ( state.isShuffleOn ) {
      playTrack( ~~( Math.random() * state.tracks.length ) )
      // playNextTrack( state.currentTrackIndex + 1 )
      console.log( ( Math.random() * state.tracks.length ), "Math random Songended" )
    } else {
      if ( state.isRepeatOn ) {
        playNextTrack()
      } else if ( state.currentTrackIndex === state.tracks.length - 1 ) {
        return
      } else {
        playNextTrack()
        state.audioPlayer.currentTime = 0
      }
      // playTrack( state.tracks[state.currentTrackIndex] )
    }
  }

  const handleVolumeChange = ( newValue ) => {
    state.audioPlayer.volume = parseFloat( newValue / 100 )
    // console.log( newValue, "newValue" )
    setVolume( newValue )
  }

  useEffect( () => {
    if ( !state.audioPlayer ) return
    const handleUpdateTime = ( e ) => {
      setTime( state.audioPlayer.currentTime )
    }
    const handleMetadata = ( e ) => {
      setDuration( state.audioPlayer.duration )
    }
    state.audioPlayer.addEventListener( 'timeupdate', handleUpdateTime )
    state.audioPlayer.addEventListener( 'loadedmetadata', handleMetadata )
    return () => {
      state.audioPlayer.removeEventListener( 'timeupdate', handleUpdateTime )
      state.audioPlayer.removeEventListener( 'loadedmetadata', handleMetadata )
    }
  }, [state.audioPlayer, state.isPlaying] )

  return {
    playTrack,
    togglePlay,
    currentTrackName: state.currentTrackIndex !== null ? state.tracks[state.currentTrackIndex].name : '',
    currentTrackImg: state.currentTrackIndex !== null && state.tracks[state.currentTrackIndex].picUrl,
    otherTrackImg: state.currentTrackIndex !== null && state.tracks[state.currentTrackIndex].al ? state.tracks[state.currentTrackIndex].al.picUrl : state.tracks[state.currentTrackIndex]?.album?.picUrl,
    currentduration: state.currentTrackIndex !== null && state.tracks[state.currentTrackIndex].dt,
    trackList: state.tracks,
    isPlaying: state.isPlaying,
    playPreviousTrack,
    playNextTrack,
    currentTrack: state.currentTrackIndex !== null && state.tracks[state.currentTrackIndex],
    currentIndex: state.currentTrackIndex,
    toggleRepeat,
    toggleShuffle,
    handleSongEnded,
    onSeek,
    trackProgress,
    duration,
    time,
    volume,
    handleVolumeChange,
    error
  }
}